interface ThalamosMarkProps {
  size?: number;
  opacity?: number;
}

export function ThalamosMark({ size = 32, opacity = 0.35 }: ThalamosMarkProps) {
  const h = (size * 52) / 60; // preserve aspect ratio
  // Bake opacity into the fill colours so the glow filter remains fully visible
  const fills = [
    `rgba(148, 163, 184, ${opacity})`,
    `rgba(100, 116, 139, ${opacity})`,
    `rgba(203, 213, 225, ${opacity})`,
  ];
  return (
    <>
      <style>{`
        @keyframes thalamos-glow {
          0%, 100% { filter: drop-shadow(0 0 3px rgba(138, 190, 35, 0.25)); }
          50% { filter: drop-shadow(0 0 10px rgba(138, 190, 35, 0.8)) drop-shadow(0 0 20px rgba(138, 190, 35, 0.3)); }
        }
      `}</style>
      <svg
        width={size}
        height={h}
        viewBox="0 0 60 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ animation: "thalamos-glow 3s ease-in-out infinite" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.782 32.9404H42.4021L50.6703 18.6718L39.8323 0H44.972L55.9776 18.6718L44.972 37.3994H23.3518L20.782 32.9404ZM27.5418 44.5894L24.9161 40.0747H46.4245L57.4301 21.2357L59.9999 25.7504L49.1061 44.5894H27.5418Z"
          fill={fills[0]}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9721 0.0557359L36.7599 0L47.5979 18.7275L45.028 23.1307L34.1342 4.51467H12.3464L14.9721 0.0557359ZM2.62571 30.265L0 25.7504L10.6704 7.02283L32.4023 7.07856L43.2403 25.8061L40.7264 30.265L29.9442 11.5932L13.4079 11.5375L2.62571 30.265Z"
          fill={fills[1]}
        />
        <path
          d="M44.8598 51.7241H23.4632L12.4575 32.885L23.2397 14.3247H28.4352L17.6531 32.885L26.033 47.2651H47.5414L44.8598 51.7241ZM20.2788 51.7241H15.1391L4.07764 32.8293L14.9157 14.3247H20.1112L9.27318 32.8293L20.2788 51.7241Z"
          fill={fills[2]}
        />
      </svg>
    </>
  );
}
